/**
 * ROWILABDEV-72: while impersonation is active the exchange `subject` describes the
 * impersonated user (usually not a superuser), so deciding whether impersonation is
 * allowed from `subject` alone is incorrect — the panel would vanish the moment
 * impersonation starts.
 *
 * Until the backend exposes the impersonator's own data on the root response
 * (ROWILABDEV-71) we infer permission from the API's behavior: the API only honors
 * `impersonate_email` for Rowi admins, so if the exchanged subject's email equals the
 * requested impersonation email, the real (Firebase) user must be an admin.
 */
export function isImpersonationHonored(userEmail, requestedEmail) {
    if (!requestedEmail || !userEmail)
        return false;
    return userEmail.trim().toLowerCase() === requestedEmail.trim().toLowerCase();
}
/** Whether impersonation controls may be shown / impersonation state may persist. */
export function mayControlImpersonation(user, requestedEmail) {
    return user.isSupportSuperuser || isImpersonationHonored(user.email, requestedEmail);
}
